<template>
  <v-dialog
    v-model="LOADING"
    fullscreen
    hide-overlay
    transition="dialog-top-transition"
  >
    <div class="text-center fullScreen">
      <img src="../assets/loading.svg" alt="" />
      <p class="overline mt-5">Please Wait..</p>
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["LOADING"]),
  },
};
</script>
<style lang="scss" scoped>
.fullScreen {
  display: flex;
  flex-direction: column;
  height: 90vh;
  align-items: center;
  justify-content: center;
}
</style>
